interface SiteIdentity {
  id?: string | null
  siteNumber?: string | null
  accountId?: string | null
}

export function siteIdentifiers(site?: SiteIdentity | null): string[] {
  return [site?.id, site?.siteNumber].filter(
    (identifier): identifier is string =>
      typeof identifier === 'string' && identifier.trim().length > 0,
  )
}

export function siteIdentifier(site?: SiteIdentity | null): string | undefined {
  return siteIdentifiers(site)[0]
}

/** Resolve legacy numbers only when the account's complete list is unambiguous. */
export function resolveSiteReference<T extends SiteIdentity>(
  sites: readonly T[],
  reference?: string | null,
  accountId?: string | null,
): T | undefined {
  if (!reference?.trim())
    return undefined
  const scoped = sites.filter(site => !accountId || !site.accountId || site.accountId === accountId)
  const byGuid = scoped.filter(site => site.id === reference)
  if (byGuid.length)
    return byGuid.length === 1 ? byGuid[0] : undefined
  const byNumber = scoped.filter(site => site.siteNumber === reference)
  return byNumber.length === 1 ? byNumber[0] : undefined
}
